import {EventEmitter, Injectable} from '@angular/core';
import {User} from '@app/models/vcr-entity/user';
import {LocalUser} from '@app/state/local-user.state';
import {RemoteUserAdditionalInfoStateModel} from '@app/state/remote-users.state';
import {RemoteParticipantInfo} from '@app/models/remote-participant-info';
import {SVGClipboard} from '@app/modules/svg/model/SVGClipboard';

@Injectable({
  providedIn: 'root'
})
export class UtilService {
  public clipboard: SVGClipboard = {
    elements: new Set(),
    text: '',
    isSafe: true,
  }; /* using WB clipboard, to make single clipboard for whole page, including WB */

  public safeClipboardEvent: EventEmitter<ClipboardEvent> = new EventEmitter();
  constructor() {}

  public static generateDisplayName(user: User): string {
    let displayName = '';
    if (!user.isGuest) {
      if (user.firstName && user.lastName) {
        displayName = user.firstName + ' ' + user.lastName.charAt(0);
      } else {
        displayName = user.name;
      }
    } else {
      displayName = 'G:' + user.name;
    }
    return displayName;
  }

  public static generateFullName(user: User | LocalUser | RemoteParticipantInfo | RemoteUserAdditionalInfoStateModel): string {
    if (user.firstName && user.lastName) {
      return user.firstName + ' ' + user.lastName;
    } else if (user.firstName) {
      return user.firstName;
    } else if (user.lastName) {
      return user.lastName;
    } else {
      return user.name;
    }
  }

  /**
   * use custom clipboard
   * */
  public safeCopy(event: ClipboardEvent): void {
    const text: string = document.getSelection()?.toString();
    if (text) {
      this.clipboard.text = text;
    }
    event.preventDefault();

    this.safeClipboardEvent.emit(event);
  }

  /**
   * use custom clipboard
   * */
  public safeCut(event: ClipboardEvent): void {
    this.replaceSelected(event.target as HTMLInputElement, '');
    event.preventDefault();

    this.safeClipboardEvent.emit(event);
  }

  /**
   * use custom clipboard
   * */
  public safePaste(event: ClipboardEvent): void {
    const paste: string = this.clipboard.text;

    this.replaceSelected(event.target as HTMLInputElement, paste);
    event.preventDefault();

    this.safeClipboardEvent.emit(event);
  }

  private replaceSelected(htmlElement: HTMLInputElement | HTMLTextAreaElement, text: string): void {
    const start: number = htmlElement.selectionStart;
    const end: number = htmlElement.selectionEnd;
    htmlElement.value = htmlElement.value.substring(0, start) + text + htmlElement.value.substring(end);
    const replacedTextEnd: number = start + text.length;
    htmlElement.setSelectionRange(replacedTextEnd, replacedTextEnd);
  }

  public parseLessonNumber(lessonName: string): number | null {
    const lessonNameSplit: string[] = lessonName.split(' ');

    if (lessonNameSplit.length > 1) {
      const expectedLessonNumber: string =
        lessonNameSplit[lessonNameSplit.length - 1]
        .replace('[^\\d-]', '');

      return parseInt(expectedLessonNumber);
    }

    return null;
  }
}
